import { getPlanFieldConfig } from './planFieldConfigs';

/**
 * Build caseSpecificData object from custom field values
 * @param {string} planName - Name of the plan
 * @param {Object} customFieldValues - Custom field values
 * @param {Object} [orgContext={}] - Organization context
 * @param {string} [orgContext.orgGroupId] - Organization group ID
 * @param {string} [orgContext.organizationId] - Organization ID
 * @returns {Object} caseSpecificData object
 */
export const buildCaseSpecificData = (planName, customFieldValues, orgContext = {}) => {
  const config = getPlanFieldConfig(planName, orgContext);
  if (!config) return {};

  const data = {};
  config.fields.forEach((field) => {
    data[field.name] = customFieldValues[field.name] ?? '';
  });
  return data;
};
